var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDonorregisterClosed(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 279.03 210.27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n\n      .cls-2 {\n        fill: #a6a6a6;\n      }\n\n      .cls-3 {\n        fill: #b1b1b1;\n        opacity: .62;\n      }\n\n      .cls-4 {\n        fill: #cadce6;\n      }\n\n      .cls-5 {\n        fill: #767676;\n      }\n\n      .cls-6 {\n        fill: #ebebeb;\n      }\n\n      .cls-7 {\n        fill: url(#linear-gradient);\n        filter: url(#drop-shadow-1);\n        stroke: #fff;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n      }\n\n      .cls-8 {\n        isolation: isolate;\n        opacity: .1;\n      }\n\n      .cls-9 {\n        fill: #3c474c;\n      }\n\n      .cls-10 {\n        fill: #263238;\n      }\n\n      .cls-11 {\n        fill: #bd4f5c;\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 261.62,
    y1: 43.36,
    x2: 218.72,
    y2: 34.44,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9d9d9d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#c4c4c4"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "drop-shadow-1",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur",
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#000",
    floodOpacity: 0.15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_4",
    "data-name": "Layer 4"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m28.98,53.86h-2.43v8.6h2.43c1.99-.01,3.3-1.31,3.3-4.28s-1.3-4.33-3.3-4.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m274.5,91.95V24.32H4.53v51.28h10.56v5.48H4.53v10.87h269.97Zm-161.42-4h-12.98v-5.49h12.98v5.49Zm28.26-21.44v-16.69h13.55v4.26h-8.09v2.29h6.76v3.6h-6.76v2.29h8.09v4.25h-13.55Zm6.1-19.88v-5.49h12.98v5.49h-12.98Zm41.29,36.79v-5.49h12.98v5.49h-12.98Zm-7.24-6.93v-5.49h12.98v5.49h-12.98Zm69.75,6.93h-12.98v-5.49h12.98v5.49Zm23.26-36.78h-6.49v-5.49h6.49v5.49Zm-13.9-12.42h12.98v5.49h-12.98v-5.49Zm-9.41,15.61c3.79,0,6.09,2.44,6.09,5.84,0,2.31-1,4.16-2.76,5.15l3.42,5.7h-5.72l-2.74-4.9h-2.41v4.9h-5.46v-16.69h9.58Zm-27.14,0h13.55v4.26h-8.09v2.29h6.76v3.6h-6.76v2.29h8.09v4.25h-13.55v-16.69Zm-17.6,0h14.23v4.26h-4.39v12.43h-5.45v-12.43h-4.4v-4.26Zm-10.22-.33c3.72,0,6.28,1.54,7.1,3.85.2.54.31,1.11.3,1.73h-5.34c0-.33-.08-.64-.25-.88-.33-.61-1.12-.96-2.2-.96-1.3,0-2.16.38-2.16,1.12.01,1,2.61,1.54,4.93,2.19,3.13.89,5.19,2.19,5.21,4.83.02,3.28-2.59,5.48-7.74,5.48-4.03,0-6.72-1.67-7.65-4.1-.26-.57-.39-1.19-.39-1.81h5.48c0,.29.06.57.21.82.33.64,1.2,1.08,2.44,1.08s2.13-.49,2.13-1.26c0-1.18-2.51-1.55-4.67-2.15-2.92-.79-5.26-2.28-5.26-4.67,0-3.36,2.96-5.27,7.84-5.27Zm-11.81.33v16.69h-5.46v-16.69h5.46Zm-9.57,5.86h-5.6c-.31-1.23-1.41-1.92-2.74-1.92-1.94,0-3.18,1.39-3.18,4.4s1.24,4.39,3.18,4.39c1.53,0,2.66-.94,2.97-2.6h-3.55v-3.19h9.08v9.75h-3.81l-.2-2.35c-.87,1.74-2.43,2.68-5.27,2.68-4.47,0-7.84-2.84-7.84-8.68s3.37-8.68,8.63-8.68c4.47,0,7.72,2.05,8.34,6.2Zm-20.18-21.47h12.98v5.49h-12.98v-5.49Zm-14.48,0h12.98v5.49h-12.98v-5.49Zm-8.72,15.61c3.79,0,6.09,2.44,6.09,5.84,0,2.31-1,4.16-2.76,5.15l3.42,5.7h-5.72l-2.74-4.9h-2.41v4.9h-5.46v-16.69h9.58Zm-29.03,0h9.58c3.79,0,6.09,2.44,6.09,5.84,0,2.31-1,4.16-2.76,5.15l3.42,5.7h-5.72l-2.74-4.9h-2.41v4.9h-5.46v-16.69Zm-39.05-15.61h12.98v5.49h-12.98v-5.49Zm-40.64,53.73h-12.98v-5.49h12.98v5.49Zm6.24-21.44h-7.89v-16.69h7.89c5.26,0,8.75,2.86,8.75,8.37s-3.49,8.32-8.75,8.32Zm20.5.33c-5.24,0-8.62-2.84-8.62-8.68s3.37-8.68,8.62-8.68,8.64,2.84,8.64,8.68-3.39,8.68-8.64,8.68Zm28.6-.33h-5.73l-5.24-8.33v8.33h-5.46v-16.69h5.75l5.24,8.33v-8.33h5.45v16.69Zm12.18-17.02c5.26,0,8.64,2.84,8.64,8.68s-3.38,8.68-8.64,8.68-8.62-2.84-8.62-8.68,3.37-8.68,8.62-8.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m251.83,55.77c0-1.29-.69-1.92-1.86-1.92h-2.91v3.84h2.91c1.17,0,1.86-.63,1.86-1.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m132.11,55.77c0-1.29-.69-1.92-1.86-1.92h-2.91v3.84h2.91c1.17,0,1.86-.63,1.86-1.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m49.48,53.77c-1.93,0-3.17,1.35-3.17,4.4s1.24,4.4,3.17,4.4,3.18-1.35,3.18-4.4-1.24-4.4-3.18-4.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m112.66,55.77c0-1.29-.69-1.92-1.86-1.92h-2.91v3.84h2.91c1.17,0,1.86-.63,1.86-1.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m90.27,62.56c1.94,0,3.18-1.35,3.18-4.4s-1.24-4.4-3.18-4.4-3.17,1.35-3.17,4.4,1.24,4.4,3.17,4.4Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 4.53,
    y: 5.62,
    width: 269.97,
    height: 13.16
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 174.81,
    y: 209.82,
    width: 99.68,
    height: 0
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 4.53,
    y: 209.82,
    width: 99.68,
    height: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "174.82 199.46 174.82 190.78 175 190.59 175 171.06 174.82 171.24 174.82 153.66 175 153.47 175 133.34 174.81 133.34 174.81 204.28 175 204.28 175 199.27 174.82 199.46"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "15.57 204.28 15.57 133.34 15.56 133.34 15.56 128.11 15.57 128.11 15.57 114.9 15.57 109.67 20.79 109.67 139.65 109.67 139.67 109.67 258.52 109.67 263.75 109.67 263.75 114.9 263.75 128.11 263.75 128.11 263.75 133.34 263.75 133.34 263.75 204.28 274.5 204.28 274.5 97.5 4.53 97.5 4.53 204.28 15.57 204.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "104.21 133.34 20.79 133.34 20.79 133.5 40.95 133.5 58.53 133.5 78.07 133.5 86.75 133.5 104.21 133.5 104.21 136.62 104.21 176.86 104.21 190.07 104.21 198.75 104.21 204.28 104.21 204.28 104.21 133.34"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 147.43,
    y: 41.14,
    width: 12.98,
    height: 5.49
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 147.43,
    y: 41.14,
    width: 12.98,
    height: 5.49
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 268,
    y: 41.14,
    width: 6.49,
    height: 5.49
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 268,
    y: 41.14,
    width: 6.49,
    height: 5.49
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 154.67,
    y: 34.21,
    width: 12.98,
    height: 5.49
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 154.67,
    y: 34.21,
    width: 12.98,
    height: 5.49
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 260.6,
    y: 34.21,
    width: 12.98,
    height: 5.49
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 260.6,
    y: 34.21,
    width: 12.98,
    height: 5.49
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 140.19,
    y: 34.21,
    width: 12.98,
    height: 5.49
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 140.19,
    y: 34.21,
    width: 12.98,
    height: 5.49
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 188.72,
    y: 77.92,
    width: 12.98,
    height: 5.49
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 188.72,
    y: 77.92,
    width: 12.98,
    height: 5.49
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 100.1,
    y: 82.46,
    width: 12.98,
    height: 5.49
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 100.1,
    y: 82.46,
    width: 12.98,
    height: 5.49
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 9.77,
    y: 82.46,
    width: 12.98,
    height: 5.49
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 9.77,
    y: 82.46,
    width: 12.98,
    height: 5.49
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 4.53,
    y: 75.59,
    width: 10.56,
    height: 5.48
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 4.53,
    y: 75.59,
    width: 10.56,
    height: 5.48
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 238.25,
    y: 77.92,
    width: 12.98,
    height: 5.49
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 238.25,
    y: 77.92,
    width: 12.98,
    height: 5.49
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 181.48,
    y: 71,
    width: 12.98,
    height: 5.49
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 181.48,
    y: 71,
    width: 12.98,
    height: 5.49
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 63.39,
    y: 34.21,
    width: 12.98,
    height: 5.49
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 63.39,
    y: 34.21,
    width: 12.98,
    height: 5.49
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "279.02 209.82 174.81 209.82 174.81 209.82 274.5 209.82 279.03 209.82 279.03 204.28 279.02 204.28 279.02 209.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "104.21 209.82 104.21 209.82 0 209.82 0 204.28 0 204.28 0 209.82 4.53 209.82 104.21 209.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "274.5 97.5 279.03 97.5 279.03 91.95 274.5 91.95 4.53 91.95 0 91.95 0 97.5 4.53 97.5 274.5 97.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "274.5 97.5 279.03 97.5 279.03 91.95 274.5 91.95 4.53 91.95 0 91.95 0 97.5 4.53 97.5 274.5 97.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "279.03 24.32 279.03 18.78 274.5 18.78 4.53 18.78 0 18.78 0 24.32 4.53 24.32 274.5 24.32 279.03 24.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "279.03 24.32 279.03 18.78 274.5 18.78 4.53 18.78 0 18.78 0 24.32 4.53 24.32 274.5 24.32 279.03 24.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "279.03 5.62 279.03 .08 0 .08 0 5.62 4.53 5.62 274.5 5.62 279.03 5.62"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "279.03 5.62 279.03 .08 0 .08 0 5.62 4.53 5.62 274.5 5.62 279.03 5.62"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 0,
    y: 204.28,
    width: 4.53,
    height: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "104.21 209.82 104.21 204.28 104.21 204.28 104.21 204.28 98.68 204.28 89.99 204.28 76.79 204.28 36.55 204.28 20.79 204.28 15.57 204.28 15.57 204.28 4.53 204.28 4.53 204.28 0 204.28 0 209.82 104.21 209.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "104.21 209.82 104.21 204.28 104.21 204.28 104.21 204.28 98.68 204.28 89.99 204.28 76.79 204.28 36.55 204.28 20.79 204.28 15.57 204.28 15.57 204.28 4.53 204.28 4.53 204.28 0 204.28 0 209.82 104.21 209.82"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 274.5,
    y: 204.28,
    width: 4.53,
    height: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "263.75 204.28 258.76 204.28 258.52 204.28 258.23 204.28 252.7 204.28 244.02 204.28 230.81 204.28 190.57 204.28 175 204.28 175 204.28 174.81 204.28 174.81 209.82 279.02 209.82 279.02 204.28 274.5 204.28 274.5 204.28 263.75 204.28 263.75 204.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "263.75 204.28 258.76 204.28 258.52 204.28 258.23 204.28 252.7 204.28 244.02 204.28 230.81 204.28 190.57 204.28 175 204.28 175 204.28 174.81 204.28 174.81 209.82 279.02 209.82 279.02 204.28 274.5 204.28 274.5 204.28 263.75 204.28 263.75 204.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "174.81 204.28 174.81 133.34 174.81 128.11 174.77 128.11 166.09 128.11 152.88 128.11 112.64 128.11 104.21 128.11 104.21 133.34 104.21 204.28 104.21 209.82 174.81 209.82 174.81 204.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "174.81 209.82 104.21 209.82 104.21 209.82 104.21 209.82 104.21 210.27 174.81 210.27 174.81 209.82 174.81 209.82 174.81 209.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "20.79 153.66 40.95 133.5 20.79 133.5 20.79 153.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "20.79 190.78 78.07 133.5 58.53 133.5 20.79 171.24 20.79 190.78"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "104.21 136.62 104.21 133.5 86.75 133.5 20.79 199.46 20.79 204.28 36.55 204.28 104.21 136.62"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "104.21 190.07 104.21 176.86 76.79 204.28 89.99 204.28 104.21 190.07"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "98.68 204.28 104.21 204.28 104.21 204.28 104.21 198.75 98.68 204.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "20.79 199.46 20.79 190.78 20.79 171.24 20.79 153.66 20.79 133.5 20.79 133.34 15.57 133.34 15.57 204.28 15.57 204.28 20.79 204.28 20.79 199.46"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 15.57,
    y: 114.9,
    width: 5.23,
    height: 13.21
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "104.21 133.34 104.21 128.11 92.07 128.11 83.38 128.11 63.85 128.11 46.27 128.11 20.79 128.11 20.79 128.11 15.57 128.11 15.56 128.11 15.56 133.34 15.57 133.34 20.79 133.34 104.21 133.34"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "59.48 114.9 77.06 114.9 96.59 114.9 105.28 114.9 125.85 114.9 139.65 114.9 139.65 109.67 20.79 109.67 15.57 109.67 15.57 114.9 20.79 114.9 59.48 114.9"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 258.52,
    y: 114.9,
    width: 5.23,
    height: 13.21
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "258.76 133.34 258.76 204.28 263.75 204.28 263.75 204.28 263.75 133.34 258.76 133.34"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "258.52 128.11 258.23 128.11 246.19 128.11 237.5 128.11 217.97 128.11 200.39 128.11 174.81 128.11 174.81 133.34 175 133.34 175 133.34 258.76 133.34 258.76 133.34 263.75 133.34 263.75 133.34 263.75 128.11 263.75 128.11 258.52 128.11 258.52 128.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "139.67 114.9 166.09 114.9 179.3 114.9 187.98 114.9 213.6 114.9 231.18 114.9 250.72 114.9 258.23 114.9 258.52 114.9 263.75 114.9 263.75 109.67 258.52 109.67 139.67 109.67 139.65 109.67 139.65 114.9 139.67 114.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "20.79 171.24 58.53 133.5 40.95 133.5 20.79 153.66 20.79 171.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "20.79 190.78 20.79 199.46 86.75 133.5 78.07 133.5 20.79 190.78"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "104.21 198.75 104.21 190.07 89.99 204.28 98.68 204.28 104.21 198.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "104.21 176.86 104.21 136.62 36.55 204.28 76.79 204.28 104.21 176.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "258.76 133.34 258.76 133.34 175 133.34 175 133.34 175 153.47 194.98 133.5 212.56 133.5 175 171.06 175 190.59 232.09 133.5 240.77 133.5 175 199.27 175 204.28 175 204.28 190.57 204.28 258.23 136.62 258.23 176.86 230.81 204.28 244.02 204.28 258.23 190.07 258.23 198.75 252.7 204.28 258.23 204.28 258.52 204.28 258.76 204.28 258.76 133.34"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "96.59 114.9 77.06 114.9 63.85 128.11 83.38 128.11 96.59 114.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "59.48 114.9 20.79 114.9 20.79 128.11 20.79 128.11 46.27 128.11 59.48 114.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "125.85 114.9 105.28 114.9 92.07 128.11 104.21 128.11 112.64 128.11 125.85 114.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "258.23 116.07 246.19 128.11 258.23 128.11 258.52 128.11 258.52 128.11 258.52 114.9 258.23 114.9 258.23 116.07"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "179.3 114.9 166.09 114.9 152.88 128.11 166.09 128.11 179.3 114.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "217.97 128.11 237.5 128.11 250.72 114.9 231.18 114.9 217.97 128.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "200.39 128.11 213.6 114.9 187.98 114.9 174.77 128.11 174.81 128.11 200.39 128.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "174.82 171.24 175 171.06 212.56 133.5 194.98 133.5 175 153.47 174.82 153.66 174.82 171.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "174.82 199.46 175 199.27 240.77 133.5 232.09 133.5 175 190.59 174.82 190.78 174.82 199.46"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "258.23 198.75 258.23 190.07 244.02 204.28 252.7 204.28 258.23 198.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "258.23 176.86 258.23 136.62 190.57 204.28 230.81 204.28 258.23 176.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "77.06 114.9 59.48 114.9 46.27 128.11 63.85 128.11 77.06 114.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "105.28 114.9 96.59 114.9 83.38 128.11 92.07 128.11 105.28 114.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "187.98 114.9 179.3 114.9 166.09 128.11 174.77 128.11 187.98 114.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "166.09 114.9 139.67 114.9 139.65 114.9 125.85 114.9 112.64 128.11 152.88 128.11 166.09 114.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "200.39 128.11 217.97 128.11 231.18 114.9 213.6 114.9 200.39 128.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "237.5 128.11 246.19 128.11 258.23 116.07 258.23 114.9 250.72 114.9 237.5 128.11"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m28.98,49.82h-7.89v16.69h7.89c5.26,0,8.75-2.81,8.75-8.32s-3.49-8.37-8.75-8.37Zm0,12.65h-2.43v-8.6h2.43c2,0,3.3,1.36,3.3,4.33s-1.31,4.27-3.3,4.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m49.48,49.49c-5.24,0-8.62,2.84-8.62,8.68s3.37,8.68,8.62,8.68,8.64-2.84,8.64-8.68-3.39-8.68-8.64-8.68Zm0,13.08c-1.93,0-3.17-1.35-3.17-4.4s1.24-4.4,3.17-4.4,3.18,1.35,3.18,4.4-1.24,4.4-3.18,4.4Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "72.64 58.15 67.4 49.82 61.65 49.82 61.65 66.51 67.11 66.51 67.11 58.18 72.36 66.51 78.09 66.51 78.09 49.82 72.64 49.82 72.64 58.15"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m90.27,66.84c5.26,0,8.64-2.84,8.64-8.68s-3.38-8.68-8.64-8.68-8.62,2.84-8.62,8.68,3.37,8.68,8.62,8.68Zm0-13.08c1.94,0,3.18,1.35,3.18,4.4s-1.24,4.4-3.18,4.4-3.17-1.35-3.17-4.4,1.24-4.4,3.17-4.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m107.9,66.51v-4.9h2.41l2.74,4.9h5.72l-3.42-5.7c1.76-.99,2.76-2.84,2.76-5.15,0-3.4-2.3-5.84-6.09-5.84h-9.58v16.69h5.46Zm0-12.66h2.91c1.17,0,1.86.63,1.86,1.92s-.69,1.92-1.86,1.92h-2.91v-3.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m121.89,66.51h5.46v-4.9h2.41l2.74,4.9h5.72l-3.42-5.7c1.76-.99,2.76-2.84,2.76-5.15,0-3.4-2.3-5.84-6.09-5.84h-9.58v16.69Zm5.46-12.66h2.91c1.17,0,1.86.63,1.86,1.92s-.69,1.92-1.86,1.92h-2.91v-3.84Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "154.89 62.25 146.79 62.25 146.79 59.96 153.55 59.96 153.55 56.37 146.79 56.37 146.79 54.08 154.89 54.08 154.89 49.82 141.34 49.82 141.34 66.51 154.89 66.51 154.89 62.25"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m157.88,58.16c0,5.84,3.37,8.68,7.84,8.68,2.84,0,4.4-.94,5.27-2.68l.2,2.35h3.81v-9.75h-9.08v3.19h3.55c-.31,1.66-1.44,2.6-2.97,2.6-1.94,0-3.18-1.38-3.18-4.39s1.24-4.4,3.18-4.4c1.34,0,2.43.69,2.74,1.92h5.6c-.62-4.15-3.87-6.2-8.34-6.2-5.26,0-8.63,2.94-8.63,8.68Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 178.96,
    y: 49.82,
    width: 5.46,
    height: 16.69
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m193.64,59.43c2.16.6,4.67.97,4.67,2.15,0,.77-.86,1.26-2.13,1.26s-2.11-.44-2.44-1.08c-.16-.25-.21-.54-.21-.82h-5.48c0,.62.13,1.24.39,1.81.93,2.43,3.62,4.1,7.65,4.1,5.15,0,7.76-2.21,7.74-5.48-.02-2.63-2.07-3.93-5.21-4.83-2.32-.66-4.92-1.19-4.93-2.19,0-.74.86-1.12,2.16-1.12,1.08,0,1.87.36,2.2.96.17.24.25.55.25.88h5.34c.01-.62-.1-1.19-.3-1.73-.82-2.31-3.38-3.85-7.1-3.85-4.89,0-7.84,1.91-7.84,5.27,0,2.4,2.34,3.89,5.26,4.67Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "210.85 66.51 216.29 66.51 216.29 54.08 220.68 54.08 220.68 49.82 206.45 49.82 206.45 54.08 210.85 54.08 210.85 66.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "237.6 66.51 237.6 62.25 229.51 62.25 229.51 59.96 236.27 59.96 236.27 56.37 229.51 56.37 229.51 54.08 237.6 54.08 237.6 49.82 224.05 49.82 224.05 66.51 237.6 66.51"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m241.6,66.51h5.46v-4.9h2.41l2.74,4.9h5.72l-3.42-5.7c1.76-.99,2.76-2.84,2.76-5.15,0-3.4-2.3-5.84-6.09-5.84h-9.58v16.69Zm5.46-12.66h2.91c1.17,0,1.86.63,1.86,1.92s-.69,1.92-1.86,1.92h-2.91v-3.84Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m104.21,127.73v82.16h35.14v-82.16h-35.14Zm29.92,10.22v50.53h-24.69v-55.4h24.69v4.87Zm3.27,41.65h-1.7v-9.24h1.7v9.24Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "124.82 133.08 109.44 148.46 109.44 150.95 127.29 133.08 124.82 133.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "119.73 173.01 134.13 158.6 134.13 155.93 117.08 173.01 119.73 173.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "109.44 133.08 109.44 143.62 119.98 133.08 109.44 133.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "134.13 173.01 134.13 170.28 131.41 173.01 134.13 173.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "109.44 173.01 114.61 173.01 134.13 153.46 134.13 137.95 109.44 162.64 109.44 173.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "115.97 188.48 134.13 188.48 134.13 176.94 127.49 176.94 115.97 188.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "109.44 176.94 109.44 178.19 110.68 176.94 109.44 176.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "113.16 176.94 109.44 180.66 109.44 183.32 115.81 176.94 113.16 176.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "109.44 150.95 109.44 162.64 134.13 137.95 134.13 133.08 127.29 133.08 109.44 150.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "131.41 173.01 134.13 170.28 134.13 158.6 119.73 173.01 131.41 173.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "115.81 176.94 109.44 183.32 109.44 188.48 115.97 188.48 127.49 176.94 115.81 176.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "110.68 176.94 109.44 178.19 109.44 180.66 113.16 176.94 110.68 176.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "117.08 173.01 134.13 155.93 134.13 153.46 114.61 173.01 117.08 173.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "119.98 133.08 109.44 143.62 109.44 148.46 124.82 133.08 119.98 133.08"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 135.7,
    y: 170.36,
    width: 1.7,
    height: 9.24
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "119.73 173.01 117.08 173.01 114.61 173.01 109.44 173.01 109.44 176.94 110.68 176.94 113.16 176.94 115.81 176.94 127.49 176.94 134.13 176.94 134.13 173.01 131.41 173.01 119.73 173.01"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m139.65,127.73v82.16h35.14v-82.16h-35.14Zm3.66,51.87h-1.7v-9.24h1.7v9.24Zm26.26-41.65v50.53h-24.69v-55.4h24.69v4.87Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "151.41 188.48 169.56 188.48 169.56 176.94 162.92 176.94 151.41 188.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "160.25 133.08 144.87 148.46 144.87 150.95 162.73 133.08 160.25 133.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "155.17 173.01 169.56 158.6 169.56 155.93 152.51 173.01 155.17 173.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "144.87 133.08 144.87 143.62 155.41 133.08 144.87 133.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "144.87 173.01 150.04 173.01 169.56 153.47 169.56 137.95 144.87 162.64 144.87 173.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "148.59 176.94 144.87 180.66 144.87 183.32 151.24 176.94 148.59 176.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "144.87 176.94 144.87 178.19 146.11 176.94 144.87 176.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "169.56 173.01 169.56 170.28 166.84 173.01 169.56 173.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "144.87 150.95 144.87 162.64 169.56 137.95 169.56 133.08 162.73 133.08 144.87 150.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "151.24 176.94 144.87 183.32 144.87 188.48 151.41 188.48 162.92 176.94 151.24 176.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "166.84 173.01 169.56 170.28 169.56 158.6 155.17 173.01 166.84 173.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "146.11 176.94 144.87 178.19 144.87 180.66 148.59 176.94 146.11 176.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "152.51 173.01 169.56 155.93 169.56 153.47 150.04 173.01 152.51 173.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "155.41 133.08 144.87 143.62 144.87 148.46 160.25 133.08 155.41 133.08"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 141.6,
    y: 170.36,
    width: 1.7,
    height: 9.24
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "155.17 173.01 152.51 173.01 150.04 173.01 144.87 173.01 144.87 176.94 146.11 176.94 148.59 176.94 151.24 176.94 162.92 176.94 169.56 176.94 169.56 173.01 166.84 173.01 155.17 173.01"
  }))), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "279.03 5.62 279.03 .08 0 .08 0 5.62 4.53 5.62 4.53 18.78 0 18.78 0 24.31 4.53 24.31 4.53 75.59 4.53 81.08 4.53 91.95 0 91.95 0 97.5 4.53 97.5 4.53 204.28 0 204.28 0 209.82 4.53 209.82 4.53 209.82 104.21 209.82 104.21 210.27 139.36 210.27 139.36 209.82 139.67 209.82 139.67 210.27 174.81 210.27 174.81 209.82 274.5 209.82 274.5 209.82 279.03 209.82 279.03 204.28 274.5 204.28 274.5 97.5 279.03 97.5 279.03 91.95 274.5 91.95 274.5 24.31 279.03 24.31 279.03 18.78 274.5 18.78 274.5 5.62 279.03 5.62"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m259.46,32.13l.4-2.58c.1-.71.16-1.41.19-2.11l.05-.49h-.05c.11-9.03-6.37-16.87-15.49-18.28-9.11-1.41-17.66,4.1-20.27,12.74h-.04s-.1.47-.1.47c-.2.68-.36,1.37-.46,2.08l-.4,2.58c-2.86-.44-5.53,1.53-5.97,4.37l-4.39,28.43c-.44,2.84,1.52,5.52,4.37,5.96l36.18,5.59c2.86.45,5.52-1.53,5.96-4.36l4.39-28.43c.44-2.85-1.52-5.52-4.36-5.97Zm-15.08,16.78c-.3,1.21-1.51,2.62-4.01,3.6-.27.11-.46.38-.45.68.17,2.73.26,4.6-.09,7.3-.05.37-.41.63-.78.58l-5.41-.84c-.38-.06-.63-.42-.58-.78.47-2.69,1.07-4.47,2.04-7.04.09-.26.03-.56-.18-.75-1.88-1.73-2.51-3.35-2.35-4.56.94-7.17,13.5-5.06,11.81,1.82Zm7.72-20.56l-.4,2.58-20.67-3.19.4-2.58c.1-.72.32-1.41.58-2.06.35-.93.83-1.77,1.39-2.54.18-.23.33-.46.53-.68.19-.22.4-.42.62-.64.26-.24.51-.48.8-.69.19-.16.4-.29.61-.43.33-.24.68-.45,1.05-.64.2-.09.4-.2.6-.29.4-.18.82-.31,1.23-.44.2-.05.39-.13.59-.18.45-.09.91-.15,1.38-.2.19-.02.38-.05.56-.06.66-.03,1.34,0,2.01.1.71.1,1.4.29,2.05.53,3.25,1.2,5.67,3.97,6.51,7.27.16.65.26,1.32.3,2.01.02.69-.01,1.41-.13,2.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m244.38,48.91c-.3,1.21-1.51,2.62-4.01,3.6-.27.11-.46.38-.45.68.17,2.73.26,4.6-.09,7.3-.05.37-.41.63-.78.58l-5.41-.84c-.38-.06-.63-.42-.58-.78.47-2.69,1.07-4.47,2.04-7.04.09-.26.03-.56-.18-.75-1.88-1.73-2.51-3.35-2.35-4.56.94-7.17,13.5-5.06,11.81,1.82Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDonorregisterClosed);
export default __webpack_public_path__ + "static/media/donorregister_closed.bd37fd11991531affe29ff094baf0352.svg";
export { ForwardRef as ReactComponent };